// extracted by mini-css-extract-plugin
export var activeFilterButton = "_nw-c";
export var backButton = "_nw-4";
export var backIcon = "_nw-5";
export var chevronShortcut = "_nw-6";
export var container = "_nw-1";
export var editor = "_nw-8";
export var editorWrapper = "_nw-7";
export var prefix = "_nw-2";
export var searchIcon = "_nw-3";
export var suffix = "_nw-9";
export var suffixContent = "_nw-a";
export var suffixText = "_nw-b";
export var wrapper = "_nw-0";